import axios from "axios";
const baseUriCoCode = `${process.env.VUE_APP_BASE_URL}/jipviomain/api/v1/cocode`;
//const baseUriCoCode = `http://localhost:9083/jipviomain/api/v1/cocode`;
export default {
  getCommonCodeMapDetail() {
    return axios({
      method: "get",
      url: `${baseUriCoCode}/detail`,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getCommonCodeMap() {
    return axios({
      method: "get",
      url: baseUriCoCode,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  }
};
